import { Application } from '../../blocks/common/components/application';
import { DeleteYourSnappiiAccountForm } from '../../blocks/pages/how-to-delete-your-snappii-account/delete-your-snappii-account-form';

class Main extends Application {
    async init() {
        await super.init();

        const deleteYourSnappiiAccountForm = new DeleteYourSnappiiAccountForm();
        deleteYourSnappiiAccountForm.init(this.store);

    }
}

const application = new Main();
application.init();
window['application'] = application;